import FeatureGateNotice from '@/hub-shared/components/FeatureGateNotice';
import type { PortalGateDecision } from './portalGates';

type GateNoticeProps = {
  decision: PortalGateDecision;
  className?: string;
};

const GateNotice = ({ decision, className }: GateNoticeProps) => {
  return <FeatureGateNotice decision={decision} className={className} />;
};

export default GateNotice;
